import { render, staticRenderFns } from "./fieldtype_phone.vue?vue&type=template&id=830a536e&scoped=true&"
import script from "./fieldtype_phone.vue?vue&type=script&lang=js&"
export * from "./fieldtype_phone.vue?vue&type=script&lang=js&"
import style0 from "./fieldtype_phone.vue?vue&type=style&index=0&id=830a536e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830a536e",
  null
  
)

export default component.exports